/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, PntSegmentsControllerGetSegmentAdOverlayByDatePathParams, PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams } from "../models/PntSegmentsControllerGetSegmentAdOverlayByDate";

export function getPntSegmentsControllerGetSegmentAdOverlayByDateUrl(slug: PntSegmentsControllerGetSegmentAdOverlayByDatePathParams["slug"]) {
  const res = { method: 'GET', url: `/pnt/v2/segments/${slug}/adoverlay` as const }
  return res
}

/**
 * @summary Retrieve the ad overlays for a time range
 * {@link /pnt/v2/segments/:slug/adoverlay}
 */
export async function pntSegmentsControllerGetSegmentAdOverlayByDate(slug: PntSegmentsControllerGetSegmentAdOverlayByDatePathParams["slug"], params: PntSegmentsControllerGetSegmentAdOverlayByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PntSegmentsControllerGetSegmentAdOverlayByDateQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getPntSegmentsControllerGetSegmentAdOverlayByDateUrl(slug).url.toString(), params, ... requestConfig })
  return res.data
}